module.exports = __webpack_public_path__ + "img/team3.f9f97d70.jpg";